import { render } from "./teacherArchives.vue?vue&type=template&id=7fbb6e1c&scoped=true"
import script from "./teacherArchives.vue?vue&type=script&lang=js"
export * from "./teacherArchives.vue?vue&type=script&lang=js"

import "./teacherArchives.vue?vue&type=style&index=0&id=7fbb6e1c&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fbb6e1c"]])

export default __exports__